import { RouteRecordRaw } from "vue-router";
import { userMustBeLoggedIn, userMustHaveApproval } from "../../router/guards";

const routes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        name: 'post-login-dashboard',
        component: () => import('./homepage.vue'),
        beforeEnter: [userMustBeLoggedIn, userMustHaveApproval]
    }
]

export default routes;